import React from 'react';
import IEStatefulBase from './IEStatefulBase';
import { DateTimePicker } from 'react-widgets';
import dateFormat from 'dateformat';

export default class IEWidgetDateTimePicker extends IEStatefulBase {
    keyDown = (event) => {
        if (event.keyCode === 27) { this.cancelEditing() }     // Escape
    };

    finishEditing = () => {
        this.props.beforeFinish && this.props.beforeFinish();
        var datetimeRef = this.refs.input.refs.inner.refs.valueInput;
        //var domElem = ReactDOM.findDOMNode(datetimeRef);
        //console.log("domElem value:" + domElem.value);
        //console.log("domElem value():" + domElem.value());
        let newValue = datetimeRef.props.value; //domElem.value;
        const result = this.doValidations(newValue);
        if (result && this.props.value !== newValue) {
            this.commit(newValue);
        }
        if (!result && this.props.handleValidationFail) {
            this.props.handleValidationFail(result, newValue, () => this.cancelEditing());
        } else {
            this.cancelEditing();
        }
        this.props.afterFinish && this.props.afterFinish();
    };

    renderEditingComponent = () => {
        return <DateTimePicker
            disabled={this.state.loading}
            className={this.makeClassString()}
            defaultValue={this.props.value}
            onInput={this.textChanged}
            //onChange={field.sync}
            onBlur={this.finishEditing}
            ref="input"
            onKeyDown={this.keyDown}
            {...this.props.editProps}
            min={new Date()}
            time={true} />;
    };

    renderNormalComponent = () => {
        const value = this.props.value;
        return <span onFocus={this.startEditing}
            onClick={this.startEditing}
            {...this.props.defaultProps}>{dateFormat(value, "mmm dd, HH:MM Z")}</span>;
    };
}



// WEBPACK FOOTER //
// ./src/components/InlineEdit/IEWidgetDateTimePicker.js